import {
  LOG_IN_TYPE,
  LOG_OUT_TYPE,
  JOIN_TYPE,
  PROFILE_TYPE,
  SET_GIGYA,
  AppThunk,
} from './actionTypes';
import authApi from '../api/auth';
import { GigyaType, SiteActionType } from '../types';

export default function loadSiteItem(
  type: SiteActionType,
  fetchFn: (gigya: GigyaType) => Promise<any>,
): AppThunk {
  return async function(dispatch, getState) {
    const gigya = getState().auth.gigya;

    dispatch({ type: type.IS_LOADING, payload: true });
    dispatch({ type: type.SET_ERROR, payload: false });
    try {
      if (!gigya) {
        throw new Error('Gigya is unavailable');
      }
      const data = await fetchFn(gigya);
      dispatch({
        type: type.SET_DATA,
        payload: data,
      });
    } catch (_e) {
      dispatch({ type: type.SET_ERROR, payload: true });
    } finally {
      dispatch({ type: type.IS_LOADING, payload: false });
    }
  };
}

export function gigyaLogin(): AppThunk {
  return async function(dispatch) {
    dispatch(loadSiteItem(LOG_IN_TYPE, authApi.logIn));
  };
}

export function gigyaLoginGiveaway():AppThunk{
  return async function (dispatch){
      dispatch(loadSiteItem(LOG_IN_TYPE, authApi.logInGiveaway));
    
  }
}

export function gigyaLogOut(): AppThunk{
  return async function(dispatch: any) {
    dispatch(loadSiteItem(LOG_OUT_TYPE, authApi.logOut));
  };
}

export function gigyaJoin(): AppThunk{
  return async function(dispatch) {
    dispatch(loadSiteItem(JOIN_TYPE, authApi.register));
  };
}

export function gigyaProfile(): AppThunk{
  return async function(dispatch) {
    dispatch(loadSiteItem(PROFILE_TYPE, authApi.profile));
  };
}

function setGigya(gigya: GigyaType): AppThunk {
  return async function(dispatch) {
    dispatch({
      type: SET_GIGYA,
      payload: gigya,
    });
    gigya.accounts.addEventHandlers({
      onLogin: () => dispatch(gigyaProfile()),
      onLogout: () =>
        dispatch({
          type: PROFILE_TYPE.SET_DATA,
          payload: { uid: null, profile: null, isLoggedIn: false },
        }),
    });
  };
}

export function gigyaInit(): AppThunk {
  return async function(dispatch) {
    const global = window as any;
    if (!global.gigya) {
      // gigya searches for this global function after it initializes.
      global.onGigyaServiceReady = function() {
        dispatch(setGigya(global.gigya));
        dispatch(gigyaProfile());
      };
    } else {
      dispatch(setGigya(global.gigya));
      dispatch(gigyaProfile());
    }
  };
}
